module.exports = __webpack_public_path__ + "img/back.90cdae9e.png";